/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
import axios from 'axios'

import firebase from 'firebase/app'
import 'firebase/auth'


import { auth } from '../../firebase/firebaseConfig'
let dashURLBase = 'https://feedback.link'

if (process.env.NODE_ENV === 'development') {
  dashURLBase = 'http://localhost:1000'
}

import router from '@/router'

export default {
  loginAttempt ({ dispatch }, payload) {

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      //notify: payload.notify,
      //closeAnimation: payload.closeAnimation
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {

      // Change firebase Persistence
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

      // If success try to login
        .then(function () {
          dispatch('login', newPayload)
        })

      // If error notify
        .catch(function (err) {

          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    } else {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  login ({ commit, state, dispatch }, payload) {

    // If user is already logged in notify and exit
    /*if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }*/

    // Try to sigin

    if (!payload.checkbox_remember_me) {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    }


    return new Promise ((resolve, reject) => {

      firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)

      .then((result) => {

        let user = auth.currentUser

        if (user) {
          commit('SET_CURRENT_USER', {...user})
        }

        resolve()

      }).catch((e) => {

        reject()

      })

    })


    },

  // Google Login
  loginWithGoogle ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.GoogleAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Facebook Login
  loginWithFacebook ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.FacebookAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Twitter Login
  loginWithTwitter ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.TwitterAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Github Login
  loginWithGithub ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.GithubAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  registerUser ({dispatch}, payload) {

    // create user using firebase

    return new Promise((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
        .then((usrcr) => {

          let LTDPartner = false

          if (typeof payload.userDetails.LTDPartner !== "undefined") {
            
            //updated in Feb '23 to detect where we got this user from (if from LTD partner), even though the 
            //actual coupon code is not recorded:
            LTDPartner = '|pt_aSCI' + payload.userDetails.LTDPartner.trim()
            //so, if |pt_aSCI3R3I8C2 then it's appsumo customer
            //if |pt_aSCIappsumo then it's appsumo customer
            ////if |pt_aSCIdealify then it's dealify customer
            ////if |pt_aSCIpitchground then it's pg customer            


            console.log(`------------${payload.userDetails.LTDPartner}`)


          }

          let user = firebase.auth().currentUser

          let newDisplayName = payload.userDetails.displayName.trim() + (LTDPartner ? LTDPartner : '')

          return user.updateProfile({
            displayName: newDisplayName
          }).then(function() {
            resolve(usrcr.uid)
          }).catch(function(error) {
            //account was created — a failed display-name update shouldn't strand the user
            resolve(usrcr.uid)
          })

        }, (error) => {
          reject(error.message)
        })
    })

  },
  'VALIDATE_COLLABORATOR_REDEEEM' ( {
    commit,
    state
  }, payload ) {
    return new Promise((resolve, reject) => {
      if (!payload.token) {
        reject()
      }
      axios.post(dashURLBase + '/api/dash/validatecollaborator', {
        email: payload.email.trim(),
        token: payload.token.trim(),
        displayName: payload.displayName.trim(),
        password: payload.password.trim()
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        //console.log('colb')
        resolve(res.data)
      }).catch((res) => {
        //noconsoleconsole.log(res)
        reject()
      })
    })
  },
  updateUsername ({ commit }, payload) {
    payload.user.updateProfile({
      displayName: payload.displayName
    }).then(() => {

      // If username update is success
      // update in localstorage
      const newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      commit('UPDATE_USER_INFO', newUserData, {root: true})

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  },









  //PIET ADDITIONS
  logout ( { commit, state, context }) {

    //noconsoleconsole.log('logout called')

    return new Promise((resolve, reject) => {
      if (state.firebaseUser) {
        auth.signOut().then(() => {
          const tURL = new URL(window.location.href)
          window.location.href = tURL.protocol + '//' + tURL.hostname + '/dash/login'
          
          //not necessary to reset state anymore, we just do refresh
          /*commit('SIGNOUT')
          commit('auth/RESET_AUTH_STATE', null, {root: true})
          commit('survey/RESET_SURVEY_STATE', null, {root: true})
          commit('dash/RESET_DASH_STATE', null, {root: true})
          commit('signUpState/RESET_SIGNUP_STATE', null, {root: true})*/
          //noconsoleconsole.log('signed out')
          resolve()
        }).catch((e) => {
          reject(e)
        })
      } else {
        reject()
      }
    })

  },
  changeDisplayName ( { commit, state}, payload ) {


    return new Promise((resolve, reject) => {

      let user = auth.currentUser

      user.updateProfile({
        displayName: payload
      }).then(function() {

        commit('SET_CURRENT_USER', {
          displayName: payload
        })

        resolve()
      }).catch(function(error) {
        //console.log(error)
        reject()
      })

    })

  },
  changePassword ( { commit, state }, payload) {

    return new Promise((resolve, reject) => {

      let user = auth.currentUser

      if (user) {

        const credential = firebase.auth.EmailAuthProvider.credential(user.email, payload.password);

        return user.reauthenticateWithCredential(credential).then(function() {

          return user.updatePassword(payload.newPassword).then(function() {
            resolve()
          }).catch(function(error) {
            reject()
          });

        }).catch(function(error) {
          reject()
        });

      } else {
        reject()
      }
    })

  },
  changeEmail ( { commit, state }, payload) {

    return new Promise((resolve, reject) => {

      let user = auth.currentUser

      if (user) {

        const credential = firebase.auth.EmailAuthProvider.credential(user.email, payload.password);

        return user.reauthenticateWithCredential(credential).then(function() {

          return user.updateEmail(payload.newEmail).then(function() {

            commit('SET_CURRENT_USER', {
              email: payload.newEmail
            })

            resolve()
          }).catch(function(error) {
            reject()
          });

        }).catch(function(error) {
          reject()
        });

      } else {
        reject()
      }
    })
  },
  sendResetPasswordEmail ({ state }, payload) {
    return new Promise ((resolve, reject) => {
      return auth.sendPasswordResetEmail(payload).then(() => {
          resolve()
      }).catch(() => {
          reject()
      })
    })
  },
  confirmResetPassword ( {state} , payload ) {
    return new Promise ((resolve, reject) => {
      return auth.confirmPasswordReset(payload.code, payload.newPassword).then(() => {
          resolve()
      }).catch(() => {
          reject()
      })
    })
  }
}
